// src/pwa-bridge.ts
// Module-level PWA state consumed by usePWA hook via PWAProvider.
// Extracted from main.tsx to break the circular dependency:
//   main.tsx → App → InstallBanner → PWAProvider → usePWA → main.tsx
// Double-underscore prefix signals internal bridge variables.

export let __pwa_updateSW: ((reloadPage?: boolean) => Promise<void>) | null = null;
export let __pwa_needsRefresh = false;
export const __pwa_listeners: Set<() => void> = new Set();

/** Called by main.tsx when registerSW fires onNeedRefresh */
export function setPwaReady(updateFn: (reloadPage?: boolean) => Promise<void>) {
    __pwa_needsRefresh = true;
    __pwa_updateSW = updateFn;
    for (const fn of __pwa_listeners) {
        fn();
    }
}
